import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VeneerService } from '@core/services/veneer.service';

export interface TimeoutStorage {
    key: string;
    model: any;
    timeout: Date;
}

export interface ILocalStorage {
    clear: () => void;
    getItem: (key: string) => string;
    key: (index: number) => string;
    removeItem: (key: string) => void;
    setItem: (key: string, value: string) => void;
    length: number;
}

@Injectable({ providedIn: 'root' })
export class StorageService {

    private static singleton: StorageService;
    private _storage: TimeoutStorage[] = [];
    private _storage$ = new BehaviorSubject<TimeoutStorage[]>(this._storage);

    constructor(private _veneerService: VeneerService) {
        if (!StorageService.singleton) {
            StorageService.singleton = this;
        }

        const veneer = this.getItem('veneer');
        if (!!veneer) {
            this._veneerService.updateVeneer(veneer as string);
        }
    }

    getItem<T>(key: string): T {
        const item = localStorage.getItem(key);
        if (!!item) {
            const itemString = item;
            return <T>JSON.parse(itemString);
        }
        return null;
    }

    clearItem(key: string) {
        localStorage.removeItem(key);
    }

    setItem(key: string, item: any) {
        const data = JSON.stringify(item);
        localStorage.setItem(key, data);
    }

    setWithTimeout(key: string, item: any, timeoutMintues: number = 1) {
        const timeperiod = new Date();
        if (key.toLowerCase().includes('cache=infinite')) {
            timeoutMintues = 600;
        }
        timeperiod.setMinutes(timeperiod.getMinutes() + timeoutMintues);
        const model: TimeoutStorage = {
            key: key,
            model: item,
            timeout: timeperiod
        };

        this._storage.push(model);
        this._storage$.next(this._storage);
    }

    getFromTimeoutStorage(key: string) {
        this._cleanupTimeoutModels();
        const found = this._storage.find(item => item.key === key);
        if (!!found) {
            return found.model;
        }
        return null;
    }

    clearTimeoutStorage() {
        this._storage = [];
        this._storage$.next(this._storage);
    }

    clearItemTimeoutStorage(key: string) {
        const filtered = this._storage.filter(item => item.key !== key);
        this._storage = filtered;
        this._storage$.next(this._storage);
    }

    private _cleanupTimeoutModels() {
        const currentTime = new Date();
        let cleaned = this._storage.filter(storage => storage.timeout > currentTime);
        if (!cleaned) {
            cleaned = [];
        }

        this._storage = cleaned;
        this._storage$.next(this._storage);
    }
}
